import { Validators } from '../../../../../utils/validators';
import { FormModel } from '../../../../../components/Form';
export const AddEditIndustryTypeForm = (strings: any, width = 3): FormModel[] => {
    const isFilter = width === 12;
    return [
        {
            label: strings.industryType,
            value: '',
            size: 'medium',
            autoFocus: false,
            type: 'text',
            typeValue: 'text',
            variant: 'outlined',
            placeholder: '',
            field: 'name',
            validators:
                width === 12
                    ? []
                    : [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 100 }],
            responsive: { xs: 12, sm: isFilter ? 12 : 6, md: width },
            required: width === 3,
        },
    ];
};
